<template>
  <div class="dialog">
    <el-dialog
      :visible.sync="changVisible"
      title="编辑角色"
      center
      width="600px"
      :before-close="$onClose"
      :destroy-on-close="false"
      @close="close()"
    >
      <div>
        <div>
          <h4 class="title">角色类型</h4>
          <el-input v-model="template_cn" placeholder="请输入"></el-input>
        </div>
        <div>
          <h4 class="title">权限</h4>
          <el-button type="primary" v-preventReClick @click="showPower()"
            >选择权限</el-button
          >
        </div>
        <div>
          <h4 class="title">状态</h4>
          <el-select v-model="status" placeholder="请选择">
            <el-option
              v-for="item in statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
      </div>

      <div class="footDialog">
        <el-button
          style="width: 106px; float: right"
          size="small"
          type="primary"
          v-preventReClick
          @click="save()"
          >保存</el-button
        >
        <el-button
          style="width: 106px; float: right; margin-right: 15px"
          size="small"
          @click="close()"
          >取消</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import preventReClick from "@/utils//preventReClick"; //防多次点击，重复提交
import * as Constant from "@/utils/constant.js";
import * as StrUtils from "@/utils/strUtils.js";

export default {
  data() {
    return {
      changVisible: false,

      apiIds: "",
      template_id: "",
      template_cn: "",
      status: "",

      statusOptions: Constant.admin_status_options, //状态
    };
  },
  props: ["apiListOptions"],
  methods: {
    $onClose(done) {
      done();
    },
    close() {
      this.$emit("closePower");
      this.changVisible = false;
      this.apiIds = "";
      this.template_cn = "";
      this.status = "";
    },
    save() {
      let clickNow = new Date().valueOf();
      if (clickNow - this.clickLastTime < 2000) return;
      this.clickLastTime = clickNow;
      if (StrUtils.isEmpty(this.status) || StrUtils.isEmpty(this.template_cn)) {
        this.$message.error("请完善信息");
        return;
      }
      if (StrUtils.isEmpty(this.apiIds)) {
        this.$message.error("请选择至少一项权限");
        return;
      }
      this.updatePowerTemplate();
    },
    showPower() {
      this.$emit("showPower", false, this.apiIds);
    },
    //页面初始化时加载的事件
    show(info) {
      this.template_id = info.id;
      this.template_cn = info.template_cn;
      this.apiIds = info.api_list;
      this.status = StrUtils.getAdminState1(info.status);
      this.changVisible = true;
    },
    // 选择完权限列表
    setPowerIds(ids) {
      this.apiIds = ids;
    },
    // 角色编辑
    updatePowerTemplate() {
      this.$api
        .updatePowerTemplate({
          token: localStorage.getItem("token"),
          template_id: this.template_id,
          template_cn: this.template_cn,
          api_list: this.apiIds,
          status: this.status,
        })
        .then(({ data }) => {
          this.$emit("toSave");
          this.close();
        })
        .catch(({ error }) => {});
    },

    /**
     * 获取api列表
     */
    getApiList(api_cns) {
      var ids = [];
      if (api_cns.indexOf("\n") != -1) {
        let cns = api_cns.split("\n");
        cns.forEach((cn) => {
          const id = this.getApiId4Cn(cn);
          if (id >= 0) {
            ids.push(id);
          }
        });
      } else {
        ids.push(this.getApiId4Cn(api_cns));
      }
      return ids;
    },
    getApiId4Cn(cn) {
      let id = -1;
      this.apiListOptions.forEach((api) => {
        if (api.label === cn) {
          id = api.value;
          return;
        }
      });
      return id + "";
    },
  },
};
</script>

<style lang="less" scoped>
.body .title {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/roleUpdateDialog.vue